import type { ProductFragment } from "@qw/graphql";
import { Badge, Icon, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@qw/ui";
import { memo } from "react";

export const ProductCard = memo(function ProductCard({
  product,
  onClick,
}: {
  product: ProductFragment;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="cursor-pointer p-2 hover:bg-background border-b last-of-type:border-0 flex justify-between align-baseline text-left w-full"
    >
      <div className="text-xs flex items-center gap-1 ">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              {product.enabled ? <Icon icon="enterprise" /> : <Icon icon="enterprise_off" />}
            </TooltipTrigger>
            <TooltipContent>{product.enabled ? "Enabled" : "Disabled"}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        {product.name || "(untitled)"}
      </div>
      <div className="text-xs text-right flex gap-2">
        <div className="flex gap-1">
          {product.linesOfBusiness?.map((lob) => (
            <TooltipProvider key={lob.id}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>{lob.code}</span>
                </TooltipTrigger>
                <TooltipContent>{lob.displayName}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ))}
        </div>
        <Badge variant="secondary">{product.marketType}</Badge>
      </div>
    </button>
  );
});
